<template lang="html">
    <div class="profile-view">
        <notification-section style="margin-right: 40px;"></notification-section>
        <profile-section></profile-section>
    </div>
</template>

<script>
import NotificationSection from './notification-section.vue';
import ProfileSection from './profile-section.vue';
export default {
    components: {
        NotificationSection,
        ProfileSection
    },
    data () {
        return {
        };
    },
    computed: {

    },
    methods: {
    }
};
</script>

<style lang="scss">
    .profile-view{
        margin-left: 140px;
        display: flex;
    }
    @media screen and (max-width: 1024px) {
        .home-view{
            margin-left: 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Profile/index.vue